export {
  ModalBody as Body,
  ModalCloseButton as CloseButton,
  ModalCloseTrigger as CloseTrigger,
  ModalContent as Content,
  ModalFooter as Footer,
  ModalHeader as Header,
  ModalOpenTrigger as OpenTrigger,
  ModalOverlay as Overlay,
  ModalPropsContext as PropsContext,
  ModalRoot as Root,
  ModalTitle as Title,
  useModalPropsContext as usePropsContext,
} from "./modal"
export type {
  ModalBodyProps as BodyProps,
  ModalCloseButtonProps as CloseButtonProps,
  ModalCloseTriggerProps as CloseTriggerProps,
  ModalContentProps as ContentProps,
  ModalFooterProps as FooterProps,
  ModalHeaderProps as HeaderProps,
  ModalOpenTriggerProps as OpenTriggerProps,
  ModalOverlayProps as OverlayProps,
  ModalRootProps as RootProps,
  ModalTitleProps as TitleProps,
} from "./modal"
